import React from "react";
import "./EventLongDescViewer.css";

export default function EventLongDescViewer({ html }) {
  // Utility: convert all <a> tags to open in new tab securely and fix missing http(s) prefix
  function processLinks(htmlString) {
    if (!htmlString) return '<span class="event-longdesc-empty">No description</span>';
    // Replace all <a ...> with <a ... target="_blank" rel="noopener noreferrer">
    // and ensure href has http/https prefix if missing
    return htmlString.replace(
      /<a\s+([^>]*href=['"])([^'"]+)(['"][^>]*)>/gi,
      (match, beforeHref, hrefValue, afterHref) => {
        let fixedHref = hrefValue;
        // Add http:// if missing protocol
        if (!/^https?:\/\//i.test(fixedHref)) {
          fixedHref = 'http://' + fixedHref;
        }
        let tag = `<a ${beforeHref}${fixedHref}${afterHref}`;
        if (!/target\s*=/.test(match)) tag += ' target="_blank"';
        if (!/rel\s*=/.test(match)) tag += ' rel="noopener noreferrer"';
        tag += '>';
        return tag;
      }
    );
  }

  return (
    <div
      className="event-longdesc-viewer"
      dangerouslySetInnerHTML={{
        __html: processLinks(html),
      }}
    />
  );
}